import { render, staticRenderFns } from "./CertificateInfoCertification.vue?vue&type=template&id=192f263a&"
import script from "./CertificateInfoCertification.vue?vue&type=script&lang=js&"
export * from "./CertificateInfoCertification.vue?vue&type=script&lang=js&"
import style0 from "./CertificateInfoCertification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports